import ReactStars from "react-stars";
const RatingStars = () => {
  return (
    
    <ReactStars count={5} size={23} value={4}/>

  );
};

export default RatingStars;